'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M12.01 5.5L10 8h4l-1.99-2.5zM18 10v4l2.5-1.99L18 10zM6 10l-2.5 2.01L6 14v-4zm8 6h-4l2.01 2.5L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z' });

var SettingsOverscan = function SettingsOverscan(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

SettingsOverscan = (0, _pure2.default)(SettingsOverscan);
SettingsOverscan.muiName = 'SvgIcon';

exports.default = SettingsOverscan;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/SettingsOverscan.js
// module id = 2826
// module chunks = 0